__turbopack_context__.v({
  "info": "styles-module-scss-module__znZUSq__info",
  "page500": "styles-module-scss-module__znZUSq__page500",
});
